<script>
import { mapState } from 'vuex'
import { PolicyForm } from '@src/forms/Property'
import Request from '@src/mixins/request'

export default {
  mixins: [Request],

  props: {
    name: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {},
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
  },

  mounted() {
    this.form = new PolicyForm(this.$route.params.property)
  },

  methods: {
    onSubmit() {
      this.updateData({
        url: this.endpoint.property.updatePolicy,
        data: {
          id: this.currentProperty.id,
          update: this.form,
        },
      })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseCard>
      <BaseControlInput label="Terms & conditions">
        <VTextarea
          v-model="form.termsAndConditions"
          label="Terms & conditions"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Privacy policy">
        <VTextarea
          v-model="form.privacyPolicy"
          label="Privacy policy"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Check-in time">
        <VAutocomplete
          v-model="form.checkInTime"
          label="Check-in time"
          color="gold"
          :items="$route.params.times"
        />
      </BaseControlInput>

      <BaseControlInput label="Check-out time">
        <VAutocomplete
          v-model="form.checkOutTime"
          label="Check-out time"
          color="gold"
          :items="$route.params.times"
        />
      </BaseControlInput>

      <BaseControlInput label="Maximum children age">
        <VTextField
          v-model="form.maximumChildrenAge"
          label="Maximum children age"
          color="gold"
          suffix="years"
        />
      </BaseControlInput>

      <BaseControlInput label="Maximum infant age">
        <VTextField
          v-model="form.maximumInfantAge"
          label="Maximum infant age"
          color="gold"
          suffix="years"
        />
      </BaseControlInput>

      <BaseControlInput label="Child disclaimer">
        <VTextarea
          v-model="form.childDisclaimer"
          label="Child disclaimer"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Drone disclaimer">
        <VTextarea
          v-model="form.droneDisclaimer"
          label="Drone disclaimer"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Outside food disclaimer">
        <VTextarea
          v-model="form.outsideFoodDisclaimer"
          label="Outside food disclaimer"
          color="gold"
        />
      </BaseControlInput>

      <VBtn
        slot="card-actions-right"
        color="gold"
        type="submit"
        :loading="loading"
        dark
      >
        Update
      </VBtn>
    </BaseCard>
  </VForm>
</template>
